import { render, staticRenderFns } from "./generateShopVideo.vue?vue&type=template&id=0b50811d&scoped=true"
import script from "./generateShopVideo.vue?vue&type=script&lang=js"
export * from "./generateShopVideo.vue?vue&type=script&lang=js"
import style0 from "./generateShopVideo.vue?vue&type=style&index=0&id=0b50811d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b50811d",
  null
  
)

export default component.exports